import React from 'react';
import { successM } from 'web-ui-kit/colors';

function SimpleCheckmark(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? successM : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 16 : _ref$width;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      width: width,
      viewBox: "0 0 16 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M5.004 9.468L1.272 5.736L0 7.008L5.004 12L15.744 1.26L14.472 0L5.004 9.468Z",
      fill: color
    }))
  );
}

export default SimpleCheckmark;